<template>
	<div class="set-main">
		<div class="set-group">
			<div>
				<input type="text" class="set-input" placeholder="请输入用户姓名" v-model="username" @input="searceName">
				<div class="search-list">
					<p 
						class="item" 
						v-for="(item,index) in searchList"
						@click="handleUserSelect(index,item.userid,item.username)"
						:key="index"
					>
						<span :class="{active: searchActive == index}">{{item.username}}</span>
					</p>
				</div>
				<h3>项目列表</h3>
				<div class="set-checkbox" ref="checkList">
					<p 
						class="item" 
						v-for="(item,index) in hospList"
						:key="index"
					>
						<span 
							@click="handleHospSelect($event,item.hos_id)"
							data-sign="show"
						>
							{{item.hos_name}}
						</span>
					</p>
				</div>
			   <div class="item-group">
			   		<button type="button" class="set-btn" @click="addAuthority">确认</button>
			   </div>
			</div>
		</div>
		<div class="nlist">
			<ul>
				<li v-for="(list,index) in allUser" :key="index">
					<h3>{{list.username}} <span @click="deleteUser(list.userid)"><i class="iconfont icon-shanchu"></i>删除</span></h3>
					<div class="set-badge">
						<p v-for="(item,index) in list.hoslist" :key="index"><span>{{item}}</span></p>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import axios from 'axios'
	export default {
		name: 'Sets',
		data () {
			return {
				username: '',
				selectName: '',
				userId: '',
				timer: null,
				searchActive: null,
				hospId: [],
				searchList:[],
				hospList: [],
				allUser: []
			}
		},
		methods: {
			searceName () {
				if(this.username.replace(/\s*/g,'')) {
					clearTimeout(this.timer)
				    this.timer = setTimeout(() => {		    	
						axios.get('/phal/public/',{
							params: {
								s: 'App.Report.Sel_username',
								username: this.username
							}
						}).then((res) => {
							let result = res.data
							if(result.ret && result.ret === 200) {
								let data = result.data
								this.searchList = data
								console.log(this.searchList)
							}
						})
					},500)
				}else{
					this.searchList = []
					this.searchActive = null
				}	
			},
			getAllHosp () {
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_hospital',
						sign: 2,
						userid : this.$store.state.userInfo.userid
					}
				}).then((res) => {
					let result = res.data
					if (result.ret && result.ret === 200) {
						let data = result.data
						this.hospList = data
					}
				})
			},
			handleUserSelect (index,userId,username) {
				this.searchActive = index
				this.userId = userId
				this.selectName = username
			},
			handleHospSelect (e, id) {
				let target = e.target
				if(target.dataset.sign == 'show'){
					target.classList.add('active')
					target.dataset.sign = 'hide'
					this.hospId.push(id)
				}else {
					target.classList.remove('active')
					target.dataset.sign = 'show'
					this.hospId.splice(this.hospId.indexOf(id),1)
				}
			},
			addAuthority () {
				if(!this.username.replace(/\s/g,'') || !this.selectName.replace(/\s/g,'')) {
					this.$alert({
						title: '提示',
						content: '请选择用户姓名'
					})
					return
				}
				if(this.hospId.length === 0) {
					this.$alert({
						title: '提示',
						content: '最少要选择一个医院'
					})
					return
				}
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Add_authority',
						userid: this.userId,
						hosid: this.hospId.join(',')	
					}
				}).then((res) => {
					let result = res.data
					if (result.ret && result.ret == 200) {
						let data = result.data
						this.showAllAuthority()
						this.$alert({
							title: '提示',
							content: '用户添加成功'
						})
					}else{
						this.$alert({
							title: '提示',
							content: '用户添加失败,请联系管理员'
						})
					}
					this.username = ''
					this.selectName = ''
					this.userId = ''
					this.hospId = []
					this.searchList = []
					this.searchActive = null
					let el = this.$refs.checkList.querySelectorAll('p')
					el.forEach((item) =>　{
						item.querySelector('span').classList.remove('active')
						item.querySelector('span').dataset.sign = 'show'
					})
				})
			},
			showAllAuthority () {
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_all_authority'
					}
				}).then((res) => {
					let result = res.data
					if (result.ret && result.ret === 200) {
						let data = result.data
						data.forEach((item) => {
							item.hoslist = item.hoslist.split(',')
						})
						this.allUser = data
					}
				})
			},
			deleteUser (userid) {
				this.$confirm({
					title: '提示',
					content: '是否删除用户',
					yesText: '取消',
					noText: '确定'
				}).then((res) =>　{
					console.log(res)
				}).catch(() => {
					axios.get('/phal/public/',{
						params: {
							s: 'App.Report.Del_user',
							userid: userid
						}
					}).then((res) => {
						let result = res.data
						if (result.ret && result.ret === 200) {
							let data = result.data
							this.showAllAuthority()
						}else{
							this.$alert({
								title: '提示',
								content: '用户删除失败,请联系管理员'
							})
						}
					})
				})
			}
		},
		mounted () {
			this.getAllHosp()
			this.showAllAuthority()
		}
	}
</script>
<style lang="stylus" scoped>
    
    .set-group
    	background:#fff
    	padding:15px
    	h3
    		padding:0
    		line-height:40px
    		margin-bottom:5px
    		color:#888
    		margin-top:5px
    		font-size:0.2rem
    	.set-input 
    		border-bottom:1px solid #dfdfdf
    		height:30px
    		line-height:30px
    		width:100%
    		color:#777
    	.search-list,
    	.set-checkbox
    		display: flex
    		flex-wrap: wrap
    		justify-content: flex-start
    		.item
    			width: 20%
    			margin-top: 10px
    			text-align: center
    			span
    				display: inline-block
    				padding: 5px 10px
    				color: #888
	    			font-size: .22rem
	    			border: 1px solid #dfdfdf
	    			border-radius: 50px
	    			&.active
	    				border:1px solid #09f
	    				color: #09f
	    			&.set-active 
		    			border:1px solid #09f
		    			color:#09f 		
    	.item-group 
    		text-align:center
    		.set-btn
    			background:#09f
    			padding:10px 40px
    			color:#fff
    			border:none
    			margin:20px auto 5px auto
    			border-radius:3px
    				
    		span
	    			border:1px solid #dfdfdf
	    			padding:5px 10px
	    			border-radius:50px
	    			color:#888
	    			font-size:0.22rem
	    			margin:0px 3px;
    .nlist
    	li
	    	padding:15px
	    	background:#fff
	    	margin-top:10px
	    	.set-badge
	    		display: flex
	    		flex-wrap: wrap
	    		padding:10px 0
	    		p
	    			width: 20%
	    			margin-top: 10px
	    			text-align: center
		    		span
		    			display: inline-block
		    			border:1px solid #09f
		    			padding:5px 10px
		    			border-radius:50px
		    			color:#09f
		    			font-size:0.22rem
		    			margin:0px 3px;

    	h3 
    		font-size:0.22rem
    		color:#666
    		font-weight:bold
    		margin-bottom:10px
    		span 
    			float:right;
    			color:#f2611a
    			font-weight:200
    			font-size:0.2rem


</style>



// WEBPACK FOOTER //
// src/pages/set/set.vue